<button
  type="button"
  class="ssw" data-tour="smartscore"
  [class.ssw--drawer]="variant === 'drawer'"
  (click)="openBreakdown()"
  [attr.aria-label]="'GAMIFICATION.SMART_SCORE'"
>
  <span class="ssw-total">
    <span class="ssw-total-emoji">⭐</span>
    <span class="ssw-total-value">{{ summary?.smartScore ?? 0 }}</span>
  </span>
  <span class="ssw-divider"></span>
  <span
    class="ssw-dim"
    *ngFor="let key of dimensionOrder"
    [style.--dim-color]="dimensions[key].color"
  >
    <span class="ssw-dim-emoji">{{ dimensions[key].emoji }}</span>
    <span class="ssw-dim-value">{{ valueFor(key) }}</span>
  </span>
</button>
